import {visibleOverlay} from "./overlay";

export function visibleCart(visible = 'toggle') {
    let flyCart = document.querySelector('.js-fly-cart'),
        header = document.querySelector('.header');

    switch (visible) {
        case 'show':
            flyCart.classList.add('_active');
            break;
        case 'hide':
            flyCart.classList.remove('_active');
            break;
        default:
            flyCart.classList.toggle('_active');
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let flyCartBtn = document.querySelector('.js-fly-cart-btn'),
        flyCartClose = document.querySelector('.js-flyCart-close'),
        header = document.querySelector('.header');
    if (flyCartBtn) {
        flyCartBtn.addEventListener('click', ()=> {
			dataLayer.push({
				'event': 'view_cart',
				'ecommerce': {
					'items': gt_order_items
				}
			});
            visibleCart();
            visibleOverlay();
            header.classList.add('_hide');
            document.body.classList.add('_no-scroll');
        })

        let flyCardInput = document.querySelector('#flyCart_promocode');
        if(flyCardInput) {
            flyCardInput.oninput = function () {
                document.querySelector('.fly-cart__promocode-btn').classList.remove('_border')
            }
        }

        if(flyCartClose) {
            flyCartClose.addEventListener('click', ()=> {
                visibleOverlay('hide');
                visibleCart('hide');
                header.classList.remove('_hide');
            })
        }
    }
});